// ../../node_modules/es-toolkit/dist/function/noop.mjs
function noop() {
}

export {
  noop
};
